<template>
    <div class="horizFlexCenter wrap"> 
        <div v-for="i in itemList" :key="i.id" :value="i.id">
            <smallbutton :buttonclass="getbuttonclass(i)"  :toplabel="i.name" @click="select(i)"/>  
        </div> 
           
    </div>
</template>
    
<script>

    import smallbutton from '../controls/button.vue'

    export default {
        name:'optionbuttonmulti',
        components:{
            smallbutton,

        },
        props:{
            itemList:{
                type:Array,
            },
           initialSelectedId:{
            type:Number,
           },
           useLargeButtons:{
            type:Boolean,
            default:false
           },
           useSmallButtons:{
            type:Boolean,
            default:false
           },
           useNarrowButtons:{
            type:Boolean,
            default:false
           }
        },
        data(){
            return{
                selectedId:0

            }
        },
        computed:{
            
        },
        methods:{
            
            getbuttonclass(item){
                if(this.useLargeButtons){
                    if(item.selected==true){
                        return " buttonprimary selectedoptionbuttonbig"
                    }else{
                        return " buttonprimary optionbuttonbig"
                    }
                }else if(this.useNarrowButtons){
                    if(item.selected==true){
                        return " buttonprimary selectedoptionbuttonnarrow"
                    }else{
                        return " buttonprimary optionbuttonnarrow"
                    }
                
                }else if(this.useSmallButtons){
                    if(item.selected==true){
                        return " buttonprimary selectedoptionbuttonsmall"
                    }else{
                        return " buttonprimary optionbuttonsmall"
                    }
                
                }else{
                    if(item.selected==true){
                        return " buttonprimary selectedoptionbutton"
                    }else{
                        return " buttonprimary optionbutton"
                    }
                }
                
            },
            select(item){
                //this.selectedId=item.id
                //item.selected=!item.selected
                console.log(item.id + ' ' + item.name )
                this.$emit('select', item.id,item.name)
            },
            selectbyid(id){
                this.selectedId=id
                this.$emit('select', this.selectedId,item.name)
            }
            
        },
        mounted(){
            console.log('mount option ' + this.initialSelectedId)
            this.selectedId=this.initialSelectedId
        }
            
        
    }
    </script>
    
    <style>
    
    .optionbutton{
        height:50px;
        width:140px;
        font-size:inherit;
        border-radius: 2px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        color:var(--button-text-color);
    }
    .selectedoptionbutton{
        height:50px;
        width:140px;
        font-size:inherit;
        border-radius: 2px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        color:var(--button-text-color);
    }
    .optionbuttonbig{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonbig{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .optionbuttonsmall{
        border-radius:5px;
        width:130px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonsmall{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .optionbuttonnarrow{
        border-radius:5px;
        width:40px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonnarrow{
        border-radius:5px;
        width:40px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    